import { Component, OnInit } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';
import { AddressService, Declination, DeclinationService, Order, OrderService, Product, ProductService, Variation, VariationService } from 'octali-lib-shop';
import * as moment from 'moment';
import { combineLatest } from 'rxjs';
import { Country, CountryService } from 'octali-lib-firebase-utils';

@Component({
  selector: 'app-order-detail',
  templateUrl: './order-detail.page.html',
  styleUrls: ['./order-detail.page.scss'],
})
export class OrderDetailPage implements OnInit {

  public order:Order;
  public products: Array<Product>
  public declinations: Array<Declination>

  public productsId: Map<string,Product>;
  public declinationsId: Map<string,Declination>;
  private variationsId: Map<string,Variation>;
  private countriesCode: Map<string,Country>;

  constructor(
    private modalCtrl: ModalController,
    private navParams: NavParams,
    private orderService:OrderService,
    private productService: ProductService,
    private declinationService: DeclinationService,
    private variationService: VariationService,
    private countryService: CountryService
  ) { 
    var items = this.navParams.get("items");
    this.order = items.order;
    combineLatest( [
      this.productService.getProductsByIdObs(),
      this.declinationService.getDeclinationsByIdObs(),
      this.variationService.getVariationsIdObs(),
      this.countryService.getCountriesByCode()
    ]).subscribe( ([productsId, declinationsId, variationsId, countriesCode]) => {
      if(productsId && declinationsId && variationsId){
        this.productsId = productsId;
        this.declinationsId = declinationsId;
        this.variationsId = variationsId;
        this.countriesCode = countriesCode;
      }
    });
  }

  ngOnInit() {
  }

  close() {
    this.modalCtrl.dismiss();
  }


  calculatePrice(price,quantity){
    return (price*quantity).toFixed(2);
  }

  getStatutDate(date){
    return moment.utc(parseInt(date)).format("DD/MM/YYYY");
  }

  getStatutName(statut){
    return this.orderService.getStatutNames().get(statut);
  }
    
  getPaiment(){
    let msg :string ="";
    for(let payment of this.order.payments)
                  msg += (<any>payment).type +" ";
    return msg;
  }

  getTitle(declination:Declination) :string{
    let vars :string="";
    if( declination )
      for( let i of declination.values ){
        vars += this.variationsId.get( i[0] ).nameValue + " " + i[1];
    }
    let product = this.productsId.get( declination.product );
    
    if( product ){
      return product.title + " " + vars;
    } else {
      return vars;
    }    
  }

  getAddress() {
    if(this.order.address != null && this.order.address != undefined && this.countriesCode){
        let add = this.order.address;
        let address:string ="";
        address += add.street + "<br/>";
        if(add.additional !="")
            address += add.additional + "<br/>";
        if(add.building !="")
            address += add.building + "<br/>";
        if(add.compagny !="")
            address += add.compagny + "<br/>";
        address += add.codePostal +" "+add.city+"<br/>";
        address += this.countriesCode.get(add.country).name+"</br>";
        address += add.phone;
        return address;
      }
    else
      return "";
  }
}
